/**
 * Created by Rupert on 29.09.2017.
 */



export class C {

    static inputDatePatternRegex = /[0-9]{4}\.[0-9]{2}\.[0-9]{2}/g;
    static inputDatePatternMoment = "YYYY.MM.DD";
    static inputDatePatternMomentScriptId = "YYYYMMDD";

    static HOUR_TYPE_ADORATION =  "Anbetung";
    static HOUR_TYPE_WORSHIP =  "Lobpreis";
    static HOUR_TYPE_SPECIAL =  "Spezial";
    static HOUR_TYPE_BLOCKED =  "Blockiert";
    static HOUR_TYPE_FASTING =  "Fasten";
    static HOUR_TYPE_TYPE2 =  "Bibel";
    static HOUR_TYPE_TYPE3 =  "Zuhause";
    static HOUR_TYPE_TYPE4 =  "Vor Ort";
    static HOUR_TYPE_TYPE5 =  "Kapelle Geistliches Zentrum";
    static HOUR_TYPE_TYPE6 =  "Loretto Gebetshaus";
    static HOUR_TYPE_TYPE7 =  "Hl. Messe";
    static HOUR_TYPE_TYPE8 =  "Rosenkranz";
    static HOUR_TYPE_TYPE9 =  "neuer Stundentyp 1";
    static HOUR_TYPE_TYPE10 =  "neuer Stundentyp 2";
    static hourTypeIdToNameMapping = [C.HOUR_TYPE_ADORATION, C.HOUR_TYPE_WORSHIP, C.HOUR_TYPE_SPECIAL, C.HOUR_TYPE_BLOCKED, C.HOUR_TYPE_FASTING, C.HOUR_TYPE_TYPE2, C.HOUR_TYPE_TYPE3, C.HOUR_TYPE_TYPE4, C.HOUR_TYPE_TYPE5, C.HOUR_TYPE_TYPE6, C.HOUR_TYPE_TYPE7, C.HOUR_TYPE_TYPE8, C.HOUR_TYPE_TYPE9, C.HOUR_TYPE_TYPE10];
    static hourTypeNameToIdMapping = {[C.HOUR_TYPE_ADORATION]: 0, [C.HOUR_TYPE_WORSHIP] : 1, [C.HOUR_TYPE_SPECIAL]: 2, [C.HOUR_TYPE_BLOCKED]: 3, [C.HOUR_TYPE_FASTING]: 4, [C.HOUR_TYPE_TYPE2]: 5, [C.HOUR_TYPE_TYPE3]: 6, [C.HOUR_TYPE_TYPE4]: 7, [C.HOUR_TYPE_TYPE5]: 8, [C.HOUR_TYPE_TYPE6]: 9, [C.HOUR_TYPE_TYPE7]: 10, [C.HOUR_TYPE_TYPE8]: 11, [C.HOUR_TYPE_TYPE9]: 12, [C.HOUR_TYPE_TYPE10]: 13};
    static hourTypeIdToDefaultColorMapping = ["rgb(49, 168, 228)", "rgb(223, 83, 62)", "rgb(59, 89, 255)", "rgb(90, 90, 90)", "rgb(111,225,151)", "#EEEEEE", "#EEEEEE", "rgb(49, 168, 228)", "rgb(49, 168, 228)", "rgb(49, 168, 228)", "rgb(49, 168, 228)", "rgb(49, 168, 228)", "rgb(49, 168, 228)", "rgb(49, 168, 228)", "rgb(49, 168, 228)"];

    static CONTACT_DATA_CELLPHONE = "CONTACT_CELLPHONE";
    static CONTACT_DATA_EMAIL = "CONTACT_EMAIL";
    static CONTACT_DATA_NONE = "CONTACT_NONE";

}

export default C;


